import { render, staticRenderFns } from "./promotion-user.vue?vue&type=template&id=b83522a8&scoped=true"
import script from "./promotion-user.vue?vue&type=script&lang=js"
export * from "./promotion-user.vue?vue&type=script&lang=js"
import style0 from "./promotion-user.vue?vue&type=style&index=0&id=b83522a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83522a8",
  null
  
)

export default component.exports